const PREFIX = 'studioaeye:choreography-snapshot:';

const key = (userId, orgId, routineId) => `${PREFIX}${encodeURIComponent(userId)}:${encodeURIComponent(orgId)}:${encodeURIComponent(routineId)}`;

export function saveRehearsalSnapshot(userId, orgId, routineId, value, storage = globalThis.sessionStorage) {
  const isDraftProjection = value?.projectionSource === 'draft'
    || value?.preview === true
    || value?.offlineCacheable === false;
  if (!storage || !userId || !orgId || !routineId || !value?.revisionId || isDraftProjection) return false;
  const safe = {
    cachedAt: new Date().toISOString(), revisionId: value.revisionId, revisionNumber: value.revisionNumber,
    title: value.title, track: { ...value.track, storageRef: undefined }, snapshot: value.snapshot,
    position: value.position, supportedModes: value.supportedModes, playbackRate: value.playbackRate,
    media: (value.media || []).map(({ storageRef, ...item }) => item), offlineManifest: value.offlineManifest,
    // T-MCRO-025: only published projections are cached; the stored entry keeps
    // that source explicit so it can never be mistaken for draft tooling.
    projectionSource: 'published',
    offlineCacheable: true, readOnly: true,
  };
  storage.setItem(key(userId, orgId, routineId), JSON.stringify(safe));
  return true;
}

export function loadRehearsalSnapshot(userId, orgId, routineId, storage = globalThis.sessionStorage) {
  if (!storage) return null;
  try { const value = JSON.parse(storage.getItem(key(userId, orgId, routineId)) || 'null'); return value?.revisionId ? value : null; } catch { return null; }
}

export function purgeRehearsalSnapshots(userId, storage = globalThis.sessionStorage) {
  if (!storage || !userId) return;
  const needle = `${PREFIX}${encodeURIComponent(userId)}:`;
  for (let index = storage.length - 1; index >= 0; index -= 1) {
    const itemKey = storage.key(index);
    if (itemKey?.startsWith(needle)) storage.removeItem(itemKey);
  }
}
